/* Bringing in some of the new Dawn code, without creating new files and file structures */

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

let subscribers = {}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback
    });
  }
};

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data)
    })
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.pageTotalElementQuickAdd = this.querySelector('quick-add-modal .slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.totalPagesQuickAdd = this.sliderItemsToShow.length - this.slidesPerPage;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPageElement && this.pageTotalElementQuickAdd) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElementQuickAdd.textContent = this.totalPagesQuickAdd;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if(this.slider.classList.contains('reviews-container__slide-banner')) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.classList.add('hidden');
      } else {
        this.prevButton.classList.remove('hidden');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.classList.add('hidden');
      } else {
        this.nextButton.classList.remove('hidden');
      }
    }

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    if(!this.slider.classList.contains('reviews-container__slide-banner')) {
      this.enableSliderLooping = true;
    }

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMultiVariantPillUnavailability();
    this.updateMasterId();
    // this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateFormLabel();
    this.updateBrandedIcons();
    this.updateMaterialText();
    if(document.getElementById("custom-text")) {
      this.updateTextBoxLimit();
    }
    if(document.getElementById('dateOption1')){
      this.updateCalendarDateOptions();
    }
    if(document.getElementById('gemOption1')){
      this.resetGemstones(this);
      this.updateGemstoneOptions();
    }
    if(document.getElementById('gemOptionSecond1')){
      this.resetGemstones2(this);
      this.updateGemstoneOptions2();
    }

    if (this.currentVariant) {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateFinalSaleAlertMessaging();
      this.updateRestockAlertMessaging();
      this.updateFewLeftLastOneMessaging();
      this.updatePreorderAlertMessaging();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        if(!this.currentVariant.available) {
          this.noWaitlistButton();
        } else {
          this.toggleAddButton(false, window.variantStrings.addToCart);
        }

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  noWaitlistButton() {
    var productHandle = document.getElementById(`ProductInfo-${this.dataset.section}`).querySelector('.product__title a').getAttribute('href');
      const url = productHandle + '.js';
      fetch(url)
      .then( res => { return res.json(); } )
      .then( data => {
        this.toggleAddButton(!this.currentVariant.available && data.tags.includes('no-waitlist') || data.tags.includes('finalsale'), window.variantStrings.soldOut);
      })
      .catch( err => { console.error(err) } )
  }

  showPresaleButton() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    addButton.removeAttribute('disabled');
    addButtonText.textContent = window.variantStrings.preorder;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    let variantPreorderDetected = false;
    variantsInfo.forEach(variant => {
      if(variant.variantMetafieldsPreorder !== '') {
        return variantPreorderDetected = true;
      }
    })

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else if(variantsInfo.find(x => x.id === this.currentVariant.id) && variantsInfo.find(x => x.id === this.currentVariant.id).inventoryPolicy === 'continue' && this.currentVariant.inventory_quantity <= 0 && !this.currentVariant.name.includes('E-Gift Card') && !productTags.includes('made_to_order')) {
      if(productInfo.productMetafieldsPreorder && variantPreorderDetected === false) {
        this.showPresaleButton();
      } else if(productInfo.productMetafieldsPreorder && variantPreorderDetected) {
        if(variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsPreorder) {
          this.showPresaleButton();
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      } else if(!productInfo.productMetafieldsPreorder && variantPreorderDetected) {
        if(variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsPreorder) {
          this.showPresaleButton(); 
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    } else if (productTags.includes('made_to_order') && variantsInfo.find(x => x.id === this.currentVariant.id).inventoryQuantity > 0) {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    } else if (productTags.includes('made_to_order')) {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.made_to_order;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  updateFinalSaleAlertMessaging() {
    if(document.querySelector('.pdp-alert') && variantsInfo.find(x => x.id === this.currentVariant.id)) {
      if(variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsFinalsale == 'true' || productTags.includes('finalsale')) {
        document.querySelector('.pdp-alert').classList.remove('hidden');
        if(variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsFinalsale) {
          document.querySelector('.alert__bold').innerHTML = productInfo.finalSaleText;
        }
      } else {
        document.querySelector('.pdp-alert').classList.add('hidden');
      }
    }
  }

  updateRestockAlertMessaging() {
    if(document.querySelector('.pdp-restock-alert')) {
      if(productInfo.productMetafieldsRestock) {
        document.querySelector('.pdp-restock-alert').classList.remove('hidden');
        document.getElementById('restockDate').innerHTML = productInfo.productMetafieldsRestock;
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsRestock) {
        document.querySelector('.pdp-restock-alert').classList.remove('hidden');
        document.getElementById('restockDate').innerHTML = variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsRestock;
      } else {
        document.querySelector('.pdp-restock-alert').classList.add('hidden');
      }
    }
  }

  updatePreorderAlertMessaging() {
    let variantPreorderDetected = false;
    variantsInfo.forEach(variant => {
      if(variant.variantMetafieldsPreorder !== '') {
        return variantPreorderDetected = true;
      }
    })

    if(document.querySelector('.pdp-preorder-alert')) {
      if(productInfo.productMetafieldsPreorder && variantPreorderDetected === false) {
        document.querySelector('.pdp-preorder-alert').classList.remove('hidden');
        document.getElementById('preorderDate').innerHTML = productInfo.productMetafieldsPreorder;
      } else if(productInfo.productMetafieldsPreorder && variantPreorderDetected) {
        if(variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsPreorder && variantsInfo.find(x => x.id === this.currentVariant.id).inventoryQuantity <= 0) {
          document.querySelector('.pdp-preorder-alert').classList.remove('hidden');
          document.getElementById('preorderDate').innerHTML = variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsPreorder; 
        } else {
          document.querySelector('.pdp-preorder-alert').classList.add('hidden');
        }
      } else if(!productInfo.productMetafieldsPreorder && variantPreorderDetected) {
        if(variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsPreorder && variantsInfo.find(x => x.id === this.currentVariant.id).inventoryQuantity <= 0) {
          document.querySelector('.pdp-preorder-alert').classList.remove('hidden');
          document.getElementById('preorderDate').innerHTML = variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsPreorder; 
        } else {
          document.querySelector('.pdp-preorder-alert').classList.add('hidden');
        }
      } else {
        document.querySelector('.pdp-preorder-alert').classList.add('hidden');
      }
    }
  }

  updateFewLeftLastOneMessaging() {
    if(document.querySelector('.pdp-alert2')) {
      if(variantsInfo.find(x => x.id === this.currentVariant.id)) {
        if(variantsInfo.find(x => x.id === this.currentVariant.id).inventoryQuantity == 1) {
          document.querySelector('.pdp-alert3').classList.remove('hidden');
          document.querySelector('.pdp-alert3 .alert__bold').innerHTML = productInfo.lastOneText;
        } else if(variantsInfo.find(x => x.id === this.currentVariant.id).inventoryQuantity <= 3 && variantsInfo.find(x => x.id === this.currentVariant.id).inventoryQuantity > 0) {
          document.querySelector('.pdp-alert3').classList.remove('hidden');
          document.querySelector('.pdp-alert3 .alert__bold').innerHTML = productInfo.fewLeftText;
        }  else {
          document.querySelector('.pdp-alert3').classList.add('hidden');
        }
      }
    }
  }

  updateTextBoxLimit() {
    let array = this.currentVariant.options;
    let index = this.currentVariant.options.length;
    while (index-- && !array[index]);
    document.getElementById("custom-text").maxLength = array[index];
  }

    updateCalendarDateOptions() {
    let currentVariantOptions = this.currentVariant.option3;

    let divList1 = document.querySelectorAll('#dateOption1 select');
    let divList2 = document.querySelectorAll('#dateOption2 select');
    let divList3 = document.querySelectorAll('#dateOption3 select');
    let divList4 = document.querySelectorAll('#dateOption4 select');
    let divArrayRemove = [];
    let divArrayAdd = [];

    if(currentVariantOptions.includes('1')) {
      document.getElementById('dateOption1').classList.remove('hidden');
      document.getElementById('dateOption2').classList.add('hidden');
      document.getElementById('dateOption3').classList.add('hidden');
      document.getElementById('dateOption4').classList.add('hidden');

      divArrayRemove = [...divList2].concat([...divList3], [...divList4]);
      divArrayRemove.forEach(div => {
        div.removeAttribute('name');
        div.removeAttribute('required');
      });

      divArrayAdd = [...divList1];
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
      });

      document.getElementById('dateOption2').removeAttribute('name');
      document.getElementById('dateOption3').removeAttribute('name');
      document.getElementById('dateOption4').removeAttribute('name');
    } else if(currentVariantOptions.includes('2')) {
      document.getElementById('dateOption1').classList.remove('hidden');
      document.getElementById('dateOption2').classList.remove('hidden');
      document.getElementById('dateOption3').classList.add('hidden');
      document.getElementById('dateOption4').classList.add('hidden');

      divArrayRemove = [...divList3].concat([...divList4]);
      divArrayRemove.forEach(div => {
        div.removeAttribute('name');
        div.removeAttribute('required');
      });

      divArrayAdd = [...divList1].concat([...divList2]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'month-2') {
            div.setAttribute('name', 'properties[Month 2]');
          } else if(div.id === 'day-2') {
            div.setAttribute('name', 'properties[Day 2]');
          }
          if(div.id === 'month-3') {
            div.setAttribute('name', 'properties[Month 3]');
          } else if(div.id === 'day-3') {
            div.setAttribute('name', 'properties[Day 3]');
          }
          if(div.id == 'month-4') {
            div.setAttribute('name', 'properties[Month 4]');
          } else if(div.id == 'day-4') {
            div.setAttribute('name', 'properties[Day 4]');
          }
        }
      });
    } else if(currentVariantOptions.includes('3')) {
      document.getElementById('dateOption1').classList.remove('hidden');
      document.getElementById('dateOption2').classList.remove('hidden');
      document.getElementById('dateOption3').classList.remove('hidden');
      document.getElementById('dateOption4').classList.add('hidden');

      divArrayRemove = [...divList4];
      divArrayRemove.forEach(div => {
        div.removeAttribute('name');
        div.removeAttribute('required');
      });

      divArrayAdd = [...divList1].concat([...divList2], [...divList3]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'month-2') {
            div.setAttribute('name', 'properties[Month 2]');
          } else if(div.id === 'day-2') {
            div.setAttribute('name', 'properties[Day 2]');
          }
          if(div.id === 'month-3') {
            div.setAttribute('name', 'properties[Month 3]');
          } else if(div.id === 'day-3') {
            div.setAttribute('name', 'properties[Day 3]');
          }
          if(div.id == 'month-4') {
            div.setAttribute('name', 'properties[Month 4]');
          } else if(div.id == 'day-4') {
            div.setAttribute('name', 'properties[Day 4]');
          }
        }
      });
    } else if(currentVariantOptions.includes('4')) {
      document.getElementById('dateOption1').classList.remove('hidden');
      document.getElementById('dateOption2').classList.remove('hidden');
      document.getElementById('dateOption3').classList.remove('hidden');
      document.getElementById('dateOption4').classList.remove('hidden');

      divArrayAdd = [...divList1].concat([...divList2], [...divList3], [...divList4]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'month-2') {
            div.setAttribute('name', 'properties[Month 2]');
          } else if(div.id === 'day-2') {
            div.setAttribute('name', 'properties[Day 2]');
          }
          if(div.id === 'month-3') {
            div.setAttribute('name', 'properties[Month 3]');
          } else if(div.id === 'day-3') {
            div.setAttribute('name', 'properties[Day 3]');
          }
          if(div.id == 'month-4') {
            div.setAttribute('name', 'properties[Month 4]');
          } else if(div.id == 'day-4') {
            div.setAttribute('name', 'properties[Day 4]');
          }
        }
      });
    }
  }

    resetGemstones() {
    let stoneInput = this.querySelectorAll('.product-form__input')[2];

    stoneInput.addEventListener('change', function(event) {
      document.getElementById('acrostic__two-stones').classList.add('hidden');
      document.getElementById('acrostic__three-stones').classList.add('hidden');
      document.getElementById('acrostic__four-stones').classList.add('hidden');
      document.getElementById('acrostic__five-stones').classList.add('hidden');

      document.querySelectorAll('[id*="-stone_stone-"] path').forEach((path) => {
        path.style.fill = 'lightgray';
      })
      document.querySelectorAll('[id*="-stone_stone-"] polygon').forEach((polygon) => {
        polygon.style.fill = 'lightgray';
      });

      var options = document.querySelectorAll('[id^="gemstone-"] option');
      for (var i = 0, l = options.length; i < l; i++) {
          options[i].selected = options[i].defaultSelected;
      }
    });


    let metalInput = this.querySelector('[acrostic__metal-tone]');

    metalInput.addEventListener('change', function(event) {
      document.getElementById('acrostic__two-stones').classList.add('hidden');
      document.getElementById('acrostic__three-stones').classList.add('hidden');
      document.getElementById('acrostic__four-stones').classList.add('hidden');
      document.getElementById('acrostic__five-stones').classList.add('hidden');

      document.querySelectorAll('[id*="-stone_stone-"] path').forEach((path) => {
        path.style.fill = 'lightgray';
      })
      document.querySelectorAll('[id*="-stone_stone-"] polygon').forEach((polygon) => {
        polygon.style.fill = 'lightgray';
      });

      var options = document.querySelectorAll('[id^="gemstone-"] option');
      for (var i = 0, l = options.length; i < l; i++) {
          options[i].selected = options[i].defaultSelected;
      }
    });
      
  }

    updateGemstoneOptions() {
    let currentVariantOption1 = this.currentVariant.option1;
    let currentVariantOptions = this.currentVariant.option3;

    let divList1 = document.querySelectorAll('#gemOption1 select');
    let divList2 = document.querySelectorAll('#gemOption2 select');
    let divList3 = document.querySelectorAll('#gemOption3 select');
    let divList4 = document.querySelectorAll('#gemOption4 select');
    let divList5 = document.querySelectorAll('#gemOption5 select');
    let divArrayRemove = [];
    let divArrayAdd = [];
    let stoneSvg = '';

    function specialColoredSvgs(dropdownSelected, svgSelected) {
      if(dropdownSelected.value == 'F - Fire Opal') {
        svgSelected[0].classList.add('svg__fire-opal');
      } else {
        svgSelected[0].classList.remove('svg__fire-opal');
      }
      if(dropdownSelected.value.includes('L - Labradorite')) {
        svgSelected[0].classList.add('svg__labradorite');
      } else {
        svgSelected[0].classList.remove('svg__labradorite');
      }
      if(dropdownSelected.value.includes('M - Moonstone')) {
        svgSelected[0].classList.add('svg__moonstone');
      } else {
        svgSelected[0].classList.remove('svg__moonstone');
      }
      if(dropdownSelected.value.includes('O - Opal')) {
        svgSelected[0].classList.add('svg__opal');
      } else {
        svgSelected[0].classList.remove('svg__opal');
      }
    }

    function removeSpecialColorSvg(dropdownSelected, svgSelected) {
      if(dropdownSelected.value !== 'F - Fire Opal' || dropdownSelected.value !== ('L - Labradorite') || dropdownSelected.value !== ('M - Moonstone') || dropdownSelected.value !== ('O - Opal')) {
        if(svgSelected[0].classList.contains('svg__fire-opal')) {
          svgSelected[0].classList.remove('svg__fire-opal');
        } else if(svgSelected[0].classList.contains('svg__labradorite')) {
          svgSelected[0].classList.remove('svg__labradorite');
        } else if(svgSelected[0].classList.contains('svg__moonstone')) {
          svgSelected[0].classList.remove('svg__moonstone');
        } else if(svgSelected[0].classList.contains('svg__opal')) {
          svgSelected[0].classList.remove('svg__opal');
        }
      }
    }
  
    function opaqueColor(hexValue, svgSelected) {
      if(hexValue.includes('*')) {
        svgSelected[0].classList.add('svg__opaque');
      } else {
        svgSelected[0].classList.remove('svg__opaque');
      }
    }
    
    if(currentVariantOptions.includes('2')) {
      document.querySelectorAll('[id*="gemstone-"]').forEach((e) => {
        e.addEventListener('change', function(event) {
          document.getElementById('acrostic__two-stones').classList.remove('hidden');
          document.getElementById('acrostic__three-stones').classList.add('hidden');
          document.getElementById('acrostic__four-stones').classList.add('hidden');
          document.getElementById('acrostic__five-stones').classList.add('hidden');

          let acrosticTwoStones = document.getElementById('acrostic__two-stones');
          if(currentVariantOption1 == 'Yellow Gold') {
            acrosticTwoStones.querySelector('.acrostic__yellow-gold').classList.remove('hidden');
            acrosticTwoStones.querySelector('.acrostic__white-gold').classList.add('hidden');
          }
          if(currentVariantOption1 == 'White Gold') {
            acrosticTwoStones.querySelector('.acrostic__yellow-gold').classList.add('hidden');
            acrosticTwoStones.querySelector('.acrostic__white-gold').classList.remove('hidden');
          }

          document.getElementById('acrostic__two-stones').classList.add('acrostic-absolute');
          document.getElementById('acrostic__three-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__four-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__five-stones').classList.remove('acrostic-absolute');

          switch(event.srcElement.id) {
            case 'gemstone-1':
              stoneSvg = document.querySelectorAll('[id="2-stone_stone-1"]');
              document.querySelectorAll('[id="2-stone_stone-1"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="2-stone_stone-1"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-2':
              stoneSvg = document.querySelectorAll('[id="2-stone_stone-2"]');
              document.querySelectorAll('[id="2-stone_stone-2"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="2-stone_stone-2"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
          }
        });
      });
      
      document.getElementById('gemOption1').classList.remove('hidden');
      document.getElementById('gemOption2').classList.remove('hidden');
      document.getElementById('gemOption3').classList.add('hidden');
      document.getElementById('gemOption4').classList.add('hidden');
      document.getElementById('gemOption5').classList.add('hidden');

      divArrayRemove = [...divList3].concat([...divList4], [...divList5]);
      divArrayRemove.forEach(div => {
        div.removeAttribute('name');
        div.removeAttribute('required');
      });

      divArrayAdd = [...divList1].concat([...divList2]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'gemstone-2') {
            div.setAttribute('name', 'properties[Stone 2]');
          }
          if(div.id === 'gemstone-3') {
            div.setAttribute('name', 'properties[Stone 3]');
          }
          if(div.id == 'gemstone-4') {
            div.setAttribute('name', 'properties[Stone 4]');
          }
          if(div.id == 'gemstone-5') {
            div.setAttribute('name', 'properties[Stone 5]');
          }
        }
      });
    } else if(currentVariantOptions.includes('3')) {
      document.querySelectorAll('[id*="gemstone-"]').forEach((e) => {
        e.addEventListener('change', function(event) {
          document.getElementById('acrostic__two-stones').classList.add('hidden');
          document.getElementById('acrostic__three-stones').classList.remove('hidden');
          document.getElementById('acrostic__four-stones').classList.add('hidden');
          document.getElementById('acrostic__five-stones').classList.add('hidden');

          let acrosticThreeStones = document.getElementById('acrostic__three-stones');
          if(currentVariantOption1 == 'Yellow Gold') {
            acrosticThreeStones.querySelector('.acrostic__yellow-gold').classList.remove('hidden');
            acrosticThreeStones.querySelector('.acrostic__white-gold').classList.add('hidden');
          }
          if(currentVariantOption1 == 'White Gold') {
            acrosticThreeStones.querySelector('.acrostic__yellow-gold').classList.add('hidden');
            acrosticThreeStones.querySelector('.acrostic__white-gold').classList.remove('hidden');
          }

          document.getElementById('acrostic__two-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__three-stones').classList.add('acrostic-absolute');
          document.getElementById('acrostic__four-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__five-stones').classList.remove('acrostic-absolute');

          switch(event.srcElement.id) {
            case 'gemstone-1':
              stoneSvg = document.querySelectorAll('[id="3-stone_stone-1"]');
              document.querySelectorAll('[id="3-stone_stone-1"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="3-stone_stone-1"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-2':
              stoneSvg = document.querySelectorAll('[id="3-stone_stone-2"]');
              document.querySelectorAll('[id="3-stone_stone-2"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="3-stone_stone-2"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-3':
              stoneSvg = document.querySelectorAll('[id="3-stone_stone-3"]');
              document.querySelectorAll('[id="3-stone_stone-3"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="3-stone_stone-3"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
          }
          
        });
      });
        
      document.getElementById('gemOption1').classList.remove('hidden');
      document.getElementById('gemOption2').classList.remove('hidden');
      document.getElementById('gemOption3').classList.remove('hidden');
      document.getElementById('gemOption4').classList.add('hidden');
      document.getElementById('gemOption5').classList.add('hidden');

      divArrayRemove = [...divList4].concat([...divList5]);
      divArrayRemove.forEach(div => {
        div.removeAttribute('name');
        div.removeAttribute('required');
      });

      divArrayAdd = [...divList1].concat([...divList2], [...divList3]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'gemstone-2') {
            div.setAttribute('name', 'properties[Stone 2]');
          }
          if(div.id === 'gemstone-3') {
            div.setAttribute('name', 'properties[Stone 3]');
          }
          if(div.id == 'gemstone-4') {
            div.setAttribute('name', 'properties[Stone 4]');
          }
          if(div.id == 'gemstone-5') {
            div.setAttribute('name', 'properties[Stone 5]');
          }
        }
      });
    } else if(currentVariantOptions.includes('4')) {
      document.querySelectorAll('[id*="gemstone-"]').forEach((e) => {
        e.addEventListener('change', function(event) {
          document.getElementById('acrostic__two-stones').classList.add('hidden');
          document.getElementById('acrostic__three-stones').classList.add('hidden');
          document.getElementById('acrostic__four-stones').classList.remove('hidden');
          document.getElementById('acrostic__five-stones').classList.add('hidden');

          let acrosticFourStones = document.getElementById('acrostic__four-stones');
          if(currentVariantOption1 == 'Yellow Gold') {
            acrosticFourStones.querySelector('.acrostic__yellow-gold').classList.remove('hidden');
            acrosticFourStones.querySelector('.acrostic__white-gold').classList.add('hidden');
          }
          if(currentVariantOption1 == 'White Gold') {
            acrosticFourStones.querySelector('.acrostic__yellow-gold').classList.add('hidden');
            acrosticFourStones.querySelector('.acrostic__white-gold').classList.remove('hidden');
          }

          document.getElementById('acrostic__two-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__three-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__four-stones').classList.add('acrostic-absolute');
          document.getElementById('acrostic__five-stones').classList.remove('acrostic-absolute');

          switch(event.srcElement.id) {
            case 'gemstone-1':
              stoneSvg = document.querySelectorAll('[id="4-stone_stone-1"]');
              document.querySelectorAll('[id="4-stone_stone-1"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="4-stone_stone-1"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-2':
              stoneSvg = document.querySelectorAll('[id="4-stone_stone-2"]');
              document.querySelectorAll('[id="4-stone_stone-2"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="4-stone_stone-2"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-3':
              stoneSvg = document.querySelectorAll('[id="4-stone_stone-3"]');
              document.querySelectorAll('[id="4-stone_stone-3"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="4-stone_stone-3"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-4':
              stoneSvg = document.querySelectorAll('[id="4-stone_stone-4"]');
              document.querySelectorAll('[id="4-stone_stone-4"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="4-stone_stone-4"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
          }
        });
      });
      
      document.getElementById('gemOption1').classList.remove('hidden');
      document.getElementById('gemOption2').classList.remove('hidden');
      document.getElementById('gemOption3').classList.remove('hidden');
      document.getElementById('gemOption4').classList.remove('hidden');
      document.getElementById('gemOption5').classList.add('hidden');

      divArrayRemove = [...divList5];
      divArrayRemove.forEach(div => {
        div.removeAttribute('name');
        div.removeAttribute('required');
      });

      divArrayAdd = [...divList1].concat([...divList2], [...divList3], [...divList4]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'gemstone-2') {
            div.setAttribute('name', 'properties[Stone 2]');
          }
          if(div.id === 'gemstone-3') {
            div.setAttribute('name', 'properties[Stone 3]');
          }
          if(div.id == 'gemstone-4') {
            div.setAttribute('name', 'properties[Stone 4]');
          }
        }
      });
    } else if(currentVariantOptions.includes('5')) {
      document.querySelectorAll('[id*="gemstone-"]').forEach((e) => {
        e.addEventListener('change', function(event) {
          document.getElementById('acrostic__two-stones').classList.add('hidden');
          document.getElementById('acrostic__three-stones').classList.add('hidden');
          document.getElementById('acrostic__four-stones').classList.add('hidden');
          document.getElementById('acrostic__five-stones').classList.remove('hidden');

          let acrosticFiveStones = document.getElementById('acrostic__five-stones');
          if(currentVariantOption1 == 'Yellow Gold') {
            acrosticFiveStones.querySelector('.acrostic__yellow-gold').classList.remove('hidden');
            acrosticFiveStones.querySelector('.acrostic__white-gold').classList.add('hidden');
          }
          if(currentVariantOption1 == 'White Gold') {
            acrosticFiveStones.querySelector('.acrostic__yellow-gold').classList.add('hidden');
            acrosticFiveStones.querySelector('.acrostic__white-gold').classList.remove('hidden');
          }
          
          document.getElementById('acrostic__two-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__three-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__four-stones').classList.remove('acrostic-absolute');
          document.getElementById('acrostic__five-stones').classList.add('acrostic-absolute');

          switch(event.srcElement.id) {
            case 'gemstone-1':
              stoneSvg = document.querySelectorAll('[id="5-stone_stone-1"]');
              document.querySelectorAll('[id="5-stone_stone-1"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="5-stone_stone-1"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-2':
              stoneSvg = document.querySelectorAll('[id="5-stone_stone-2"]');
              document.querySelectorAll('[id="5-stone_stone-2"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="5-stone_stone-2"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-3':
              stoneSvg = document.querySelectorAll('[id="5-stone_stone-3"]');
              document.querySelectorAll('[id="5-stone_stone-3"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="5-stone_stone-3"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-4':
              stoneSvg = document.querySelectorAll('[id="5-stone_stone-4"]');
              document.querySelectorAll('[id="5-stone_stone-4"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              })
              document.querySelectorAll('[id="5-stone_stone-4"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-5':
              stoneSvg = document.querySelectorAll('[id="5-stone_stone-5"]');
              document.querySelectorAll('[id="5-stone_stone-5"] path').forEach((path) => {
                if(this.options[this.selectedIndex].value.includes('F - Fire Opal') || this.options[this.selectedIndex].value.includes('L - Labradorite') || this.options[this.selectedIndex].value.includes('M - Moonstone') || this.options[this.selectedIndex].value.includes('O - Opal')) {
                  specialColoredSvgs(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                } else {
                  removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                  opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                  path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
                }
              });
              document.querySelectorAll('[id="5-stone_stone-5"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
          }
        });
      });
      
      document.getElementById('gemOption1').classList.remove('hidden');
      document.getElementById('gemOption2').classList.remove('hidden');
      document.getElementById('gemOption3').classList.remove('hidden');
      document.getElementById('gemOption4').classList.remove('hidden');
      document.getElementById('gemOption5').classList.remove('hidden');

      divArrayAdd = [...divList1].concat([...divList2], [...divList3], [...divList4], [...divList5]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'gemstone-2') {
            div.setAttribute('name', 'properties[Stone 2]');
          }
          if(div.id === 'gemstone-3') {
            div.setAttribute('name', 'properties[Stone 3]');
          }
          if(div.id == 'gemstone-4') {
            div.setAttribute('name', 'properties[Stone 4]');
          }
          if(div.id == 'gemstone-5') {
            div.setAttribute('name', 'properties[Stone 5]');
          }
        }
      });
    }
  }

  resetGemstones2() {
    let stoneInput = this.querySelectorAll('.product-form__input')[0];

    stoneInput.addEventListener('change', function(event) {
      document.getElementById('charm__three-stones').classList.add('hidden');
      document.getElementById('charm__four-stones').classList.add('hidden');

      document.querySelectorAll('[id*="-stone_stone-"] path').forEach((path) => {
        path.style.fill = 'lightgray';
      })
      document.querySelectorAll('[id*="-stone_stone-"] polygon').forEach((polygon) => {
        polygon.style.fill = 'lightgray';
      });

      var options = document.querySelectorAll('[id^="gemstone-"] option');
      for (var i = 0, l = options.length; i < l; i++) {
          options[i].selected = options[i].defaultSelected;
      }
    });
      
  }

    updateGemstoneOptions2() {
    let currentVariantOption1 = this.currentVariant.option1;
    let currentVariantOptions = this.currentVariant.option1;

    let divList1 = document.querySelectorAll('#gemOptionSecond1 select');
    let divList2 = document.querySelectorAll('#gemOptionSecond2 select');
    let divList3 = document.querySelectorAll('#gemOptionSecond3 select');
    let divList4 = document.querySelectorAll('#gemOptionSecond4 select');
    let divArrayRemove = [];
    let divArrayAdd = [];
    let stoneSvg = '';
  
    function opaqueColor(hexValue, svgSelected) {
      if(hexValue.includes('*')) {
        svgSelected[0].classList.add('svg__opaque');
      } else {
        svgSelected[0].classList.remove('svg__opaque');
      }
    }
    
  if(currentVariantOptions.includes('3')) {
      document.querySelectorAll('[id*="gemstone-"]').forEach((e) => {
        e.addEventListener('change', function(event) {
          document.getElementById('charm__three-stones').classList.remove('hidden');
          document.getElementById('charm__four-stones').classList.add('hidden');

          let acrosticThreeStones = document.getElementById('charm__three-stones');

          document.getElementById('charm__three-stones').classList.add('acrostic-absolute');
          document.getElementById('charm__four-stones').classList.remove('acrostic-absolute');

          switch(event.srcElement.id) {
            case 'gemstone-second-1':
              stoneSvg = document.querySelectorAll('[id="3-stone_stone-1"]');
              document.querySelectorAll('[id="3-stone_stone-1"] path').forEach((path) => {
                removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              })
              document.querySelectorAll('[id="3-stone_stone-1"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-second-2':
              stoneSvg = document.querySelectorAll('[id="3-stone_stone-2"]');
              document.querySelectorAll('[id="3-stone_stone-2"] path').forEach((path) => {
                removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              })
              document.querySelectorAll('[id="3-stone_stone-2"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-second-3':
              stoneSvg = document.querySelectorAll('[id="3-stone_stone-3"]');
              document.querySelectorAll('[id="3-stone_stone-3"] path').forEach((path) => {
                removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              })
              document.querySelectorAll('[id="3-stone_stone-3"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
          }
          
        });
      });
        
      document.getElementById('gemOptionSecond1').classList.remove('hidden');
      document.getElementById('gemOptionSecond2').classList.remove('hidden');
      document.getElementById('gemOptionSecond3').classList.remove('hidden');
      document.getElementById('gemOptionSecond4').classList.add('hidden');

      divArrayRemove = [...divList4].concat([...divList4]);
      divArrayRemove.forEach(div => {
        div.removeAttribute('name');
        div.removeAttribute('required');
      });

      divArrayAdd = [...divList1].concat([...divList2], [...divList3]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'gemstone-second-2') {
            div.setAttribute('name', 'properties[Stone 2]');
          }
          if(div.id === 'gemstone-second-3') {
            div.setAttribute('name', 'properties[Stone 3]');
          }
          if(div.id == 'gemstone-second-4') {
            div.setAttribute('name', 'properties[Stone 4]');
          }
          if(div.id == 'gemstone-second-5') {
            div.setAttribute('name', 'properties[Stone 5]');
          }
        }
      });
    } else if(currentVariantOptions.includes('4')) {
      document.querySelectorAll('[id*="gemstone-"]').forEach((e) => {
        e.addEventListener('change', function(event) {
          document.getElementById('charm__three-stones').classList.add('hidden');
          document.getElementById('charm__four-stones').classList.remove('hidden');

          let charmFourStones = document.getElementById('charm__four-stones');

          document.getElementById('charm__three-stones').classList.remove('acrostic-absolute');
          document.getElementById('charm__four-stones').classList.add('acrostic-absolute');

          switch(event.srcElement.id) {
            case 'gemstone-second-1':
              stoneSvg = document.querySelectorAll('[id="4-stone_stone-1"]');
              document.querySelectorAll('[id="4-stone_stone-1"] path').forEach((path) => {
                removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              })
              document.querySelectorAll('[id="4-stone_stone-1"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-second-2':
              stoneSvg = document.querySelectorAll('[id="4-stone_stone-2"]');
              document.querySelectorAll('[id="4-stone_stone-2"] path').forEach((path) => {
                removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              })
              document.querySelectorAll('[id="4-stone_stone-2"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-second-3':
              stoneSvg = document.querySelectorAll('[id="4-stone_stone-3"]');
              document.querySelectorAll('[id="4-stone_stone-3"] path').forEach((path) => {
                removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              })
              document.querySelectorAll('[id="4-stone_stone-3"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
            case 'gemstone-second-4':
              stoneSvg = document.querySelectorAll('[id="4-stone_stone-4"]');
              document.querySelectorAll('[id="4-stone_stone-4"] path').forEach((path) => {
                removeSpecialColorSvg(this.options[this.selectedIndex], stoneSvg);
                opaqueColor(this.options[this.selectedIndex].getAttribute('hex-value'), stoneSvg);
                path.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              })
              document.querySelectorAll('[id="4-stone_stone-4"] polygon').forEach((polygon) => {
                polygon.style.fill = this.options[this.selectedIndex].getAttribute('hex-value').replace(/\*/g,'');
              });
              break;
          }
        });
      });
      
      document.getElementById('gemOptionSecond1').classList.remove('hidden');
      document.getElementById('gemOptionSecond2').classList.remove('hidden');
      document.getElementById('gemOptionSecond3').classList.remove('hidden');
      document.getElementById('gemOptionSecond4').classList.remove('hidden');

      divArrayAdd = [...divList1].concat([...divList2], [...divList3], [...divList4]);
      divArrayAdd.forEach(div => {
        div.setAttribute('required', 'required');
        if(!div.hasAttribute('name')) {
          if(div.id === 'gemstone-second-2') {
            div.setAttribute('name', 'properties[Stone 2]');
          }
          if(div.id === 'gemstone-second-3') {
            div.setAttribute('name', 'properties[Stone 3]');
          }
          if(div.id == 'gemstone-second-4') {
            div.setAttribute('name', 'properties[Stone 4]');
          }
        }
      });
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMaterialText() {
    if(variantsInfo.find(x => x.id === this.currentVariant.id)) {
      if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42729604251824) {
        document.querySelector('.product-description__options-variant').innerHTML = 'Plated';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42849849508016) {
        document.querySelector('.product-description__options-variant').innerHTML = '9k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42849849540784) {
        document.querySelector('.product-description__options-variant').innerHTML = '14k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42746835501232) {
        document.querySelector('.product-description__options-variant').innerHTML = '14k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 43172103848112) {
        document.querySelector('.product-description__options-variant').innerHTML = '9k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42987239375024) {
        document.querySelector('.product-description__options-variant').innerHTML = '9k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42966272377008) {
        document.querySelector('.product-description__options-variant').innerHTML = '9k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42966272409776) {
        document.querySelector('.product-description__options-variant').innerHTML = '9k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42966272311472) {
        document.querySelector('.product-description__options-variant').innerHTML = '9k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 42966272344240) {
        document.querySelector('.product-description__options-variant').innerHTML = '9k Solid Gold';
      } else if(variantsInfo.find(x => x.id === this.currentVariant.id).id == 43190930702512) {
        document.querySelector('.product-description__options-variant').innerHTML = '9k Solid Gold';
      }
    }
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.retainMultiVariantPillUnavailability();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      // return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      // const checkedRadioOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
      const checkedRadioOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked) || fieldset.querySelector('select option:checked');
      if(checkedRadioOption) {
        return checkedRadioOption.value;
      }
    });
  }

  updateMultiVariantPillUnavailability() {
    const checkForMultiVariants = this.getVariantData().filter(variant => variant.option2 !== null);
    if(checkForMultiVariants.length !== 0) {
      const possibleVariantsOption1 = this.getVariantData().filter(variant => variant.option1 === this.options[0]);
      for (let index = 0; index < possibleVariantsOption1.length; index++) {
        const variantOption1 = possibleVariantsOption1[index];
        const unavailablePillOption2 = document.querySelector(`[value="${variantOption1.option2}"]`);
        if (!variantOption1.available) {
          unavailablePillOption2.classList.add('unavailable');
        } else {
          unavailablePillOption2.classList.remove('unavailable');
        }
      }

      const possibleVariantsOption2 = this.getVariantData().filter(variant => variant.option2 === this.options[1]);
      for (let index = 0; index < possibleVariantsOption2.length; index++) {
        const variantOption2 = possibleVariantsOption2[index];
        const unavailablePillOption1 = document.querySelector(`[value="${variantOption2.option1}"]`);
        if (!variantOption2.available) {
          unavailablePillOption1.classList.add('unavailable');
        } else {
          unavailablePillOption1.classList.remove('unavailable');
        }
      }
    }
  }

  updateFormLabel() {
    const formLabelVariant = document.querySelector('.form__label-variant');
    if(this.currentVariant && formLabelVariant) {
      if(document.querySelector(`[class="product-form__swatch ${this.currentVariant.option1.toLowerCase().replace(/'/g, '').replace(/\s+/g, '-')}"]`)) {
        formLabelVariant.innerHTML = this.currentVariant.option1;
        document.querySelector('.option__divider').classList.remove('option__divider-hidden');
      } else if(document.querySelector(`[class="product-form__swatch a${this.currentVariant.option1.toLowerCase().replace(/\s+/g, '-')}"]`)) {
        formLabelVariant.innerHTML = this.currentVariant.option1;
        document.querySelector('.option__divider').classList.remove('option__divider-hidden');
      } else if(document.querySelector(`[class="product-form__swatch a${this.currentVariant.option1.toLowerCase().replace(/\s+/g, '-')} product-form__product-family-text"]`)) {
        formLabelVariant.innerHTML = this.currentVariant.option1;
        document.querySelector('.option__divider').classList.remove('option__divider-hidden');
      } else if(document.querySelector('.charms-product__info') && document.querySelector('.charms-product__info').querySelector(`[class="product-form__swatch ${this.currentVariant.option1.replace("- ", "-").toLowerCase().replace(/\s+/g, '-')}"]`)) {
        formLabelVariant.innerHTML = this.currentVariant.option1;
        document.querySelector('.option__divider').classList.remove('option__divider-hidden');
      } else if(document.querySelector('.charms-product__info') && document.querySelector('.charms-product__info').querySelector(`[class="product-form__swatch ${this.currentVariant.option1.replace(" - ", "-").toLowerCase().replace(/\s+/g, '-')}"]`)) {
        formLabelVariant.innerHTML = this.currentVariant.option1;
        document.querySelector('.option__divider').classList.remove('option__divider-hidden');
      } else {
        formLabelVariant.innerHTML = this.currentVariant.option2;
        document.querySelector('.option__divider').classList.remove('option__divider-hidden');
      }
    }
  }

  updateBrandedIcons() {
    let hideReturnsForFinalSale = document.querySelectorAll('.branded-icons__container.hideReturnsForFinalSale');
    let showFastShippingForFinalSale = document.querySelectorAll('.branded-icons__container.showFastShippingForFinalSale');
    let internationalShipping = document.querySelector('.branded-icons__container.internationalShipping');
    if(internationalShipping.classList.contains('hidden')) {
      if(variantsInfo.find(x => x.id === this.currentVariant.id)) {
        if(variantsInfo.find(x => x.id === this.currentVariant.id).variantMetafieldsFinalsale == 'true') {
          hideReturnsForFinalSale.forEach(element => {
            element.classList.add('hidden');
          });
          showFastShippingForFinalSale.forEach(element => {
            element.classList.remove('hidden');
          });
        } else {
          hideReturnsForFinalSale.forEach(element => {
            element.classList.remove('hidden');
          });
          showFastShippingForFinalSale.forEach(element => {
            element.classList.add('hidden');
          });
        }
      }
    }
  }

  retainMultiVariantPillUnavailability() {
    let variantOptionArr = [];
    var variantPills = document.querySelectorAll('input');

    for (var i = 0, length = variantPills.length; i < length; i++) {
      if (variantPills[i].checked) {
        variantOptionArr.push(variantPills[i].value);
      }
    }

    function filterForUnavailablePills(options) {
      const unavailablePillOption1 = document.querySelector(`[value="${options.option1}"]`);
      const unavailablePillOption2 = document.querySelector(`[value="${options.option2}"]`);

      if(Object.values(options).indexOf(variantOptionArr[1]) > -1 && unavailablePillOption1) {          
        if (!options.available && unavailablePillOption1) {
          unavailablePillOption1.classList.add('unavailable');
        } else {
          unavailablePillOption1.classList.remove('unavailable');
        }
      }
      if(Object.values(options).indexOf(variantOptionArr[0]) > -1 && unavailablePillOption2) {          
        if (!options.available) {
          unavailablePillOption2.classList.add('unavailable');
        } else {
          unavailablePillOption2.classList.remove('unavailable');
        }
      }
    }
    this.getVariantData().filter(filterForUnavailablePills);
  }
}

customElements.define('variant-radios', VariantRadios);

function screenWatcher(mediaQuery){
  const collapseableItems = document.querySelectorAll('.footer__accordion')
  
  if (mediaQuery.matches) {
      collapseableItems.forEach(element => {
          element.querySelector('.footer-block__heading').addEventListener('click', footerAccordion)
          element.setAttribute('aria-expanded', false)
      });
  } else {
      collapseableItems.forEach(element => {
          if (element.querySelector('ul').classList.contains('is-visible')) {
            element.querySelector('ul').classList.remove('is-visible')
          }
          if (element.hasAttribute('aria-expanded')) {
            element.removeAttribute('aria-expanded')
          }
          element.querySelector('h2').removeEventListener('click', footerAccordion)
      });
  }
}

function footerAccordion(e) {
  e.currentTarget.parentElement.querySelector('ul').classList.toggle('is-visible')
  e.currentTarget.parentElement.setAttribute(
    'aria-expanded',
    `${!(e.currentTarget.parentElement.getAttribute('aria-expanded') === 'true')}`
  )
}

const mediaQuery = window.matchMedia('(max-width: 900px)')
screenWatcher(mediaQuery)
mediaQuery.addEventListener('change', screenWatcher)